<template>
  <div class="template">
    <HomepageParams />
    <LoaderFullPage v-if="store.loading" />
    <HomepageDatas v-else />
  </div>
</template>

<script lang="ts" setup>
import LoaderFullPage from "@follaw-fr/components/reusable/molecules/LoaderFullPage.vue";
import HomepageParams from "@follaw-fr/components/homepage/organisms/HomepageParams.vue";
import HomepageDatas from "@follaw-fr/components/homepage/organisms/HomepageDatas.vue";
import { useHomepageStore } from "@follaw-fr/stores/homepage";
import { useRoute } from "vue-router";

const store = useHomepageStore();
const route = useRoute();

if (route.fullPath.includes("follawed")) {
  store.isFollawedActive = true;
} else {
  store.isFollawedActive = false;
}

store.basePayload.from = 0;
store.fetchHomepage();
</script>
